import styled from 'styled-components';
import {ReactComponent as SearchIconSvg} from '../round-search.svg';

export const SearchIcon = styled(SearchIconSvg)`
    margin-right: 10px;
    color: #fff;
    width: 20px;
    height: 20px;
`;
